(function($){
    $(function(){  //document.ready

			//show hide search bar
			$("li.search a.site-nav__link").click(function() {
				$(".site-header__search").toggle();
			});


    });

    //Functions, Plugins, Etc.. Here
    //(does not wait for DOM READY STATE) 

})(jQuery);